import React from 'react';
import { SEO, Banner } from '../../common';
import { ReportList } from '../../report';
import { Layout } from '../../layout';

function Cases({ posts, pdf }) {
  return (
    <Layout>
      <SEO title="Reporte Imagenológico Dentomaxilofacial" />
      <Banner text={<>Reporte Imagenológico Dentomaxilofacial</>} />
      <ReportList posts={posts} pdf={pdf} />
    </Layout>
  );
}

export default Cases;
